import { getWappSession } from 'weblite-web-wapprunner'
import {
  eventSocketConnected,
  eventSocketDisconnected,
} from '@weblite-wapps/protocol'
import { areTopicsRelated } from './helpers'
import { connectionStatusView } from '$comp/main/root.reducer'
import { getWapp } from '$logic/wapps/service'
import { sendEventToAllWapps } from '$logic/wapp-communication/wapp-communication.publish'

// wappGroupName -> topic -> Set<wappSessionId>
const subscriptions: Record<string, Record<string, Set<string>>> = {}

export async function subscribeWappSessionToTopic(
  topic: string,
  wappSessionId: string,
) {
  const { wappId } = getWappSession(wappSessionId) || {}
  if (!wappId) return

  const { groupName } = (await getWapp(wappId)) || {}
  if (!groupName) return

  // Subscribe session to given topic

  if (!(groupName in subscriptions)) subscriptions[groupName] = {}

  const sessionIdsSet = subscriptions[groupName][topic]

  if (!sessionIdsSet) subscriptions[groupName][topic] = new Set([wappSessionId])
  else sessionIdsSet.add(wappSessionId)
}

export async function unsubscribeWappSession(wappSessionId: string) {
  const { wappId } = getWappSession(wappSessionId) || {}
  if (!wappId) return

  const { groupName } = (await getWapp(wappId)) || {}
  if (!groupName || !subscriptions[groupName]) return

  // Remove sessionId subscriptions
  const groupNameSubscriptions = subscriptions[groupName]
  Object.keys(groupNameSubscriptions).forEach(topic => {
    const set = groupNameSubscriptions[topic]

    if (set.has(wappSessionId)) set.delete(wappSessionId)
    if (!set.size) delete groupNameSubscriptions[topic]
  })

  if (!Object.keys(subscriptions[groupName]).length)
    delete subscriptions[groupName]
}

export function getWappSessionsSubscribedToTopic(
  groupName: string,
  topic: string,
): string[] {
  const groupNameSubscriptions = subscriptions[groupName]
  if (!groupNameSubscriptions) return []

  const registeredTopics = Object.keys(groupNameSubscriptions)
  const subscribedSessionIds = registeredTopics
    .filter(registeredTopic => areTopicsRelated(topic, registeredTopic))
    .map(registeredTopic => groupNameSubscriptions[registeredTopic])
    .reduce((unionSet, set) => {
      if (!set) return unionSet
      set.forEach(sessionId => unionSet.add(sessionId))

      return unionSet
    }, new Set<string>())

  return Array.from(subscribedSessionIds)
}

export function sendSocketConnectedEventToWapps() {
  sendEventToAllWapps(session => eventSocketConnected(null, session))
}

export function sendSocketDisconnectedEventToWapps() {
  sendEventToAllWapps(session => eventSocketDisconnected(null, session))
}
